import api from "!../../../node_modules/.pnpm/style-loader@2.0.0_webpack@4.44.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../node_modules/.pnpm/css-loader@5.0.1_webpack@4.44.2/node_modules/css-loader/dist/cjs.js!../../../node_modules/.pnpm/vue-loader@15.9.5_snackhrvn2skq2fk5zrw2w5ryi/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/.pnpm/stylus-loader@4.3.1_nouf5yjtdn62wms6jnhbmmgdcm/node_modules/stylus-loader/dist/cjs.js??ref--1-2!../../../node_modules/.pnpm/vue-loader@15.9.5_snackhrvn2skq2fk5zrw2w5ryi/node_modules/vue-loader/lib/index.js??vue-loader-options!./_wrapper.vue?vue&type=style&index=0&id=12f38049&lang=stylus&scoped=true&";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};